var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAviPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 140,
    rx: 8,
    fill: "#EBEBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70 20C64.1063 20 58.454 22.3413 54.2865 26.5087C50.119 30.6762 47.7778 36.3285 47.7778 42.2222C47.7778 48.1159 50.119 53.7682 54.2865 57.9357C58.454 62.1032 64.1063 64.4444 70 64.4444C75.8937 64.4444 81.546 62.1032 85.7135 57.9357C89.881 53.7682 92.2222 48.1159 92.2222 42.2222C92.2222 36.3285 89.881 30.6762 85.7135 26.5087C81.546 22.3413 75.8937 20 70 20ZM54.8521 86.1694C53.1413 84.5543 50.8019 83.6022 48.5265 84.2005C34.0838 87.9978 20 95.2982 20 106.111V114C20 117.314 22.6863 120 26 120H114C117.314 120 120 117.314 120 114V106.111C120 95.2982 105.916 87.9978 91.4735 84.2005C89.1981 83.6022 86.8587 84.5543 85.1479 86.1694C81.1869 89.9088 75.878 92.2222 70 92.2222C64.122 92.2222 58.8131 89.9088 54.8521 86.1694Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAviPlaceholder);
export default __webpack_public_path__ + "static/media/aviPlaceholder.e61565b6346d1aba01b0cd5759fa37de.svg";
export { ForwardRef as ReactComponent };